import React from 'react';
import validate from './validation';
import './confirmationCode.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'
import String from "../../../../Assets/Localization/local";
import { MyTicket_PATH } from '../../../../AppConfig'
import { Redirect } from 'react-router-dom';
import RenderField from '../../../../Components/Fields/fields';
import { confirmCode } from '../../../../Redux/Action/ForgetAction'

import { Link } from "react-router-dom";
import { forgetPassword } from '../../../../Redux/Action/ForgetAction'
import { back } from '../../../../Redux/Action/ForgetAction'
import LoadingBar from 'react-redux-loading-bar';
import Timer from 'react-timer'
import {Form} from 'reactstrap';
import logoPart1 from '../../../../Assets/Images/logoWihte.png'
class ConfirmCode extends React.Component {
  constructor() {
    super();
    this.state = {
      redirect: false,
      selectedOption: "ADMIN",
      startTimer: false,
      seconds: 0,
      showRetry: false
    }
    this.radioChange = this.radioChange.bind(this);

  }
  stopTimer() {
    clearInterval(this.interval);
  }
  tick() {
    this.setState(prevState => ({
      seconds: prevState.seconds + 1,
    }));
    if (this.state.seconds === 60) {
      this.setState({ startTimer: false, showRetry: true, seconds: 0 }, () => {
        this.stopTimer()
      })

    }
  }

  radioChange(e) {
    this.setState({
      selectedOption: e.currentTarget.value
    });
  }
  componentWillMount() {
    this.setState({ startTimer: true }, () => {
      this.interval = setInterval(() => this.tick(), 1000);
    })
  }

  onSubmit = (values) => {
    values.type = this.props.type;
    values.email = this.props.email;
    this.props.confirmCode(values, this.props.lang);
  }
  ReSend = () => {
    this.setState({ startTimer: true, showRetry: false }, () => {
      this.interval = setInterval(() => this.tick(), 1000);
    })
    if (this.props.email !== undefined && this.props.type !== undefined) {
      let values = {};
      values.email = this.props.email;
      values.type = this.props.type
      this.props.forgetPassword(values, this.props.lang);
    }

  }
  render() {
    const OPTIONS = { delay: 100 }

    const { handleSubmit } = this.props
    String.setLanguage(this.props.lang)
    if (this.props.page === "newPasswordPage") {
      return <Redirect to={{pathname:`${MyTicket_PATH}MyTicket/newPasswordPage`,
    state:{
      type:this.props.location.state.type
    }}} />
    }
    return (
      <div className="loginClass" style={{ textAlign: 'center', color: 'white' }}>
         <div className="loginClass-2">
        <div className="loading-bar" >
          <LoadingBar style={{ height: '3px', zIndex: 1250, backgroundImage: `linear-gradient(to right, #FF5438, #FF8044)` }} />
        </div>
        <div className="OverLay">
          <div className="LoginContainer">
            <div className="LoginForm">
              <img alt="part_one" src={logoPart1} className="img-fluid LogoPartt1Login" style={{margin:'0 auto', width: '60px', height: '60px' }} />
               
              <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="FormContent" id="code-confirm">
                <Field
                  component={RenderField}
                  type="text"
                  name="code"
                  lang={this.props.lang}
                  icone=""
                  placeholder={this.props.lang === "ar" ? "الرمز التاكيدي" : "Confirm Code"}
                  loginBool="true"
                  inputType="maxLength"
                />
                {
                  this.state.startTimer && <Timer options={OPTIONS} />
                }
                {this.state.showRetry &&
                  <div className="mt-3" style={{cursor:"pointer", textDecoration: 'underline' }} onClick={() => { this.ReSend(this) }}>
                    <i class="fas fa-undo"></i> <span> {String.ReSendKey}</span>
                  </div>
                  //  <Link onClick={() => {
                  //    this.ReSend(this)}} className="loginBtn" style={{ textDecoration: 'none' }} >
                  //      {String.ReSendKey} </Link>
                }
                <button type="submit" value="Login" className={this.state.startTimer ? "loginBtn px-5 mt-3" : "loginBtn px-5 mt-5"}>{String.SendKey} </button>

                <div>
                  <Link to={'/MyTicket/admin-login'}style={{ textDecoration: 'underline',float:this.props.lang==="ar"?"right":"left"}} className="BackLink">{String.BackBtn}</Link>
                  <Link to={{pathname:'/MyTicket/forgetpassword',
                state:{
                  type:this.props.location.state.type
                }}} onClick={()=>this.props.back()} style={{ textDecoration: 'underline' ,float:this.props.lang==="ar"?"left":"right"}} className="BackLink">{String.BackToEmail}</Link>
                </div>

              </Form>
            </div>
          </div>
        </div>
        </div>
      </div >
    );
  }
}


const mapDispatchToProps = dispatch => bindActionCreators(

  {
    confirmCode,
    forgetPassword,
    back
  }
  , dispatch
)


const mapStateToProps = state => {

  return {
    lang: state.userInfo.language,
    token: state.userInfo.token,
    page: state.forgetPass.page,
    email: state.forgetPass.email,
    type: state.forgetPass.type,
    
  }
}

export default reduxForm({
  form: 'confirm-code',
  validate
})(connect(mapStateToProps, mapDispatchToProps)(ConfirmCode));

